
import { last, sort, singleton, collect, item, tryItem, zip, min as min_1, filter, head, cons, fold, tail, isEmpty, reverse, map, pairwise, length, empty, mapIndexed, append, ofArray } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { DrawModelType_SymbolT_DirectedPortId, DrawModelType_BusWireT_Msg, DrawModelType_BusWireT_TextOffset_get_xLeftOffset, DrawModelType_BusWireT_TextOffset_get_xOffset, DrawModelType_BusWireT_TextOffset_get_yOffset, DrawModelType_BusWireT_WireType_$reflection, DrawModelType_BusWireT_Wire_$reflection, DrawModelType_BusWireT_Segment, DrawModelType_BusWireT_WireType } from "../Model/DrawModelType.js";
import { makePolygon, Polygon, defaultPolygon, makePathFromAttr, makeLineAttr, makePartArcAttr, makeCircle, makeAnyPath, Circle, defaultCircle, Path, defaultPath, makeText, Text$ } from "../Common/DrawHelpers.js";
import { max, min } from "../fable_modules/fable-library-js.5.13.0/Double.js";
import { HighLightColor, HighLightColor__Text, XYPos_$reflection, Edge_$reflection, HighLightColor_$reflection, Connection, Port, XYPos } from "../Common/CommonTypes.js";
import { interpolate, join, toText, printf, toFail } from "../fable_modules/fable-library-js.5.13.0/String.js";
import { comparePrimitives, int32ToString, equals } from "../fable_modules/fable-library-js.5.13.0/Util.js";
import { toList, FSharpMap__get_Item } from "../fable_modules/fable-library-js.5.13.0/Map.js";
import { getAbsSegments, segmentsToIssieVertices } from "./BlockHelpers.js";
import { Record } from "../fable_modules/fable-library-js.5.13.0/Types.js";
import { record_type, bool_type, float64_type, string_type } from "../fable_modules/fable-library-js.5.13.0/Reflection.js";
import { SVGAttr } from "../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { value as value_1, defaultArg } from "../fable_modules/fable-library-js.5.13.0/Option.js";
import * as react from "react";
import { keyValueList } from "../fable_modules/fable-library-js.5.13.0/MapUtil.js";
import { getTimeMs } from "../Common/TimeHelpers.js";
import { FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E } from "../fable_modules/Fable.React.9.4.0/Fable.React.FunctionComponent.fs.js";
import { Helpers_equalsButFunctions } from "../fable_modules/Fable.React.9.4.0/Fable.React.Helpers.fs.js";
import { view as view_1 } from "./SymbolView.js";
import { getPortLocation } from "./Symbol.js";
import { contains } from "../fable_modules/fable-library-js.5.13.0/Set.js";

export const Constants_debugWireSegments = false;

export const Constants_rainbowColours = ofArray(["#FF0000", "#FF7F00", "#FFFF00", "#00FF00", "#00A0A0", "#1010FF", "#9B50FF", "#FF00FF"]);

export const Constants_initialWireType = DrawModelType_BusWireT_WireType.Radial;

export const Constants_initialArrowDisplay = true;

export const Constants_jumpRadius = 5;

export const Constants_nubLength = 10;

export const Constants_cornerRadius = 7;

export const Constants_modernCircleRadius = 3;

export const Constants_modernCirclePositionTolerance = 2;

export const Constants_vertexLoadMatchTolerance = 0.01;

export const Constants_busWidthTextStyle = new Text$("left", "12px", "Bold", "Verdana, Arial, Helvetica, sans-serif", "", "none", "middle");

/**
 * Identifies a segment as wire:index, short enough to read in a log line.
 */
export function logSegmentId(seg) {
    return `${seg.WireId}:${seg.Index}`;
}

/**
 * Given the coordinates of two port locations that correspond
 * to the endpoints of a wire, as well as the final port orientation
 * this function returns a list of wire vertices.
 * The starting segment will always be from a Right Edge (and so in increasing X direction)
 * 
 * The two positions are where the wire LEAVES each symbol's bounding box, which for nearly every
 * port is the port itself. Where it is not - a Mux2's Sel sits nine units inside the box, because
 * the symbol is drawn as a trapezium and the port is on the sloping side - the caller hands this
 * the point on the box and lengthens the two end nubs afterwards, so that everything here works
 * in the space a wire is actually free to use. See BusWireUpdateHelpers.autoroute.
 */
export function makeInitialWireVerticesList(wireStartPos, wireEndPos, portOrientation) {
    const yStart = wireStartPos.Y;
    const yEnd = wireEndPos.Y;
    const xStart = wireStartPos.X;
    const xEnd = wireEndPos.X;
    let roomForNub;
    const xDelta = xEnd - xStart;
    let matchResult;
    switch (portOrientation.tag) {
        case 2: {
            if (xDelta > 0) {
                matchResult = 0;
            }
            else {
                matchResult = 2;
            }
            break;
        }
        case 0: {
            if (xDelta > 0) {
                matchResult = 1;
            }
            else {
                matchResult = 2;
            }
            break;
        }
        case 1: {
            if (xDelta > 0) {
                matchResult = 1;
            }
            else {
                matchResult = 2;
            }
            break;
        }
        default:
            matchResult = 2;
    }
    switch (matchResult) {
        case 0: {
            roomForNub = min(Constants_nubLength, xDelta / 2);
            break;
        }
        case 1: {
            roomForNub = min(Constants_nubLength, xDelta);
            break;
        }
        default:
            roomForNub = Constants_nubLength;
    }
    const startNub = roomForNub;
    const endNub = roomForNub;
    const rightNub = ofArray([new XYPos(xStart, yStart), new XYPos(xStart + startNub, yStart), new XYPos(xStart + startNub, yStart)]);
    const rightwards = (xStart - xEnd) < 0;
    const downwards = (yStart - yEnd) < 0;
    if (rightwards) {
        if (downwards) {
            switch (portOrientation.tag) {
                case 3:
                    return append(rightNub, ofArray([new XYPos(xEnd + 10, yStart), new XYPos(xEnd + 10, yEnd), new XYPos(xEnd + endNub, yEnd), new XYPos(xEnd + endNub, yEnd), new XYPos(xEnd, yEnd)]));
                case 1:
                    return append(rightNub, ofArray([new XYPos((xEnd + xStart) / 2, yStart), new XYPos((xEnd + xStart) / 2, yEnd + 10), new XYPos(xEnd, yEnd + 10), new XYPos(xEnd, yEnd + endNub), new XYPos(xEnd, yEnd + endNub), new XYPos(xEnd, yEnd)]));
                case 2:
                    return append(rightNub, ofArray([new XYPos((xEnd + xStart) / 2, yStart), new XYPos((xEnd + xStart) / 2, yEnd), new XYPos(xEnd - endNub, yEnd), new XYPos(xEnd - endNub, yEnd), new XYPos(xEnd, yEnd)]));
                default:
                    return append(rightNub, ofArray([new XYPos(xEnd, yStart), new XYPos(xEnd, yEnd - endNub), new XYPos(xEnd, yEnd - endNub), new XYPos(xEnd, yEnd)]));
            }
        }
        else {
            switch (portOrientation.tag) {
                case 3:
                    return append(rightNub, ofArray([new XYPos(xEnd + 10, yStart), new XYPos(xEnd + 10, yEnd), new XYPos(xEnd + endNub, yEnd), new XYPos(xEnd + endNub, yEnd), new XYPos(xEnd, yEnd)]));
                case 0:
                    return append(rightNub, ofArray([new XYPos((xEnd + xStart) / 2, yStart), new XYPos((xEnd + xStart) / 2, yEnd - 10), new XYPos(xEnd, yEnd - 10), new XYPos(xEnd, yEnd - endNub), new XYPos(xEnd, yEnd - endNub), new XYPos(xEnd, yEnd)]));
                case 2:
                    return append(rightNub, ofArray([new XYPos((xEnd + xStart) / 2, yStart), new XYPos((xEnd + xStart) / 2, yEnd), new XYPos(xEnd - endNub, yEnd), new XYPos(xEnd - endNub, yEnd), new XYPos(xEnd, yEnd)]));
                default:
                    return append(rightNub, ofArray([new XYPos(xEnd, yStart), new XYPos(xEnd, yEnd + endNub), new XYPos(xEnd, yEnd + endNub), new XYPos(xEnd, yEnd)]));
            }
        }
    }
    else if (downwards) {
        switch (portOrientation.tag) {
            case 3:
                return append(rightNub, ofArray([new XYPos((xStart + startNub) + 10, yStart), new XYPos((xStart + startNub) + 10, yEnd), new XYPos(xEnd + endNub, yEnd), new XYPos(xEnd + endNub, yEnd), new XYPos(xEnd, yEnd)]));
            case 0:
                return ofArray([new XYPos(xStart, yStart), new XYPos(xStart + startNub, yStart), new XYPos(xStart + startNub, (yStart + yEnd) / 2), new XYPos(xEnd, (yStart + yEnd) / 2), new XYPos(xEnd, yEnd - endNub), new XYPos(xEnd, yEnd - endNub), new XYPos(xEnd, yEnd)]);
            case 2:
                return append(rightNub, ofArray([new XYPos((xStart + startNub) + 10, yStart), new XYPos((xStart + startNub) + 10, (yStart + yEnd) / 2), new XYPos(xEnd - 10, (yStart + yEnd) / 2), new XYPos(xEnd - 10, yEnd), new XYPos(xEnd - endNub, yEnd), new XYPos(xEnd - endNub, yEnd), new XYPos(xEnd, yEnd)]));
            default:
                return append(rightNub, ofArray([new XYPos((xStart + startNub) + 10, yStart), new XYPos((xStart + startNub) + 10, yEnd + 10), new XYPos(xEnd, yEnd + 10), new XYPos(xEnd, yEnd + endNub), new XYPos(xEnd, yEnd + endNub), new XYPos(xEnd, yEnd)]));
        }
    }
    else {
        switch (portOrientation.tag) {
            case 3:
                return append(rightNub, ofArray([new XYPos((xStart + startNub) + 10, yStart), new XYPos((xStart + startNub) + 10, yEnd), new XYPos(xEnd + endNub, yEnd), new XYPos(xEnd + endNub, yEnd), new XYPos(xEnd, yEnd)]));
            case 1:
                return ofArray([new XYPos(xStart, yStart), new XYPos(xStart + startNub, yStart), new XYPos(xStart + startNub, (yStart + yEnd) / 2), new XYPos(xEnd, (yStart + yEnd) / 2), new XYPos(xEnd, yEnd + endNub), new XYPos(xEnd, yEnd + endNub), new XYPos(xEnd, yEnd)]);
            case 2:
                return append(rightNub, ofArray([new XYPos((xStart + startNub) + 10, yStart), new XYPos((xStart + startNub) + 10, (yStart + yEnd) / 2), new XYPos(xEnd - 10, (yStart + yEnd) / 2), new XYPos(xEnd - 10, yEnd), new XYPos(xEnd - endNub, yEnd), new XYPos(xEnd - endNub, yEnd), new XYPos(xEnd, yEnd)]));
            default:
                return ofArray([new XYPos(xStart, yStart), new XYPos(xStart + startNub, yStart), new XYPos(xStart + startNub, yEnd - 10), new XYPos(xEnd, yEnd - 10), new XYPos(xEnd, yEnd - endNub), new XYPos(xEnd, yEnd - endNub), new XYPos(xEnd, yEnd)]);
        }
    }
}

/**
 * Converts a list of vertices into a list of segments
 */
export function xyVerticesToSegments(connId, xyVerticesList) {
    return mapIndexed((i, tupledArg) => {
        const _arg = tupledArg[0];
        const _arg_1 = tupledArg[1];
        return new DrawModelType_BusWireT_Segment(i, ((_arg_1.X - _arg.X) + _arg_1.Y) - _arg.Y, connId, empty(), !((i === 0) ? true : (i === (length(xyVerticesList) - 2))), "auto");
    }, pairwise(xyVerticesList));
}

/**
 * Given the coordinates of two port locations that correspond
 * to the endpoints of a wire, as well as the orientation of the final port
 * this function returns a list of Segment(s).
 * The starting segment will always be from a Right Edge (and so in increasing X direction)
 */
export function makeInitialSegmentsList(hostId, startPos, endPos, portOrientation) {
    return xyVerticesToSegments(hostId, makeInitialWireVerticesList(startPos, endPos, portOrientation));
}

/**
 * Convert a (possibly legacy) issie Connection stored as a list of vertices to a list of segments
 */
export function issieVerticesToSegments(connId, verticesList) {
    let verts, tupledArg_2, _arg_1, vL_1, v2_3, v1_3;
    const xyVerticesList = map((tupledArg) => ({
        Mode: tupledArg[2] ? "manual" : "auto",
        Pos: new XYPos(tupledArg[0], tupledArg[1]),
    }), verticesList);
    const segT = (v1, v2) => {
        let delta;
        const left = v1;
        const right = v2;
        delta = (new XYPos(left.X - right.X, left.Y - right.Y));
        if ((Math.abs(delta.X) + Math.abs(delta.Y)) < 1E-07) {
            return undefined;
        }
        else if (Math.abs(delta.Y) < 1E-07) {
            return "horizontal";
        }
        else if (Math.abs(delta.X) < 1E-07) {
            return "vertical";
        }
        else {
            return toFail(printf("Diagonal vertices read in Wire"));
        }
    };
    return mapIndexed((i, tupledArg_3) => {
        const endVertex = tupledArg_3[0];
        const startVertex = tupledArg_3[1];
        return new DrawModelType_BusWireT_Segment(i, ((endVertex.Pos.X - startVertex.Pos.X) + endVertex.Pos.Y) - startVertex.Pos.Y, connId, empty(), !((i === 0) ? true : (i === (length(xyVerticesList) - 2))), endVertex.Mode);
    }, (verts = xyVerticesList, reverse(!isEmpty(verts) ? (!isEmpty(tail(verts)) ? ((tupledArg_2 = fold((tupledArg_1, v3) => {
        const _arg = tupledArg_1[0];
        const vL = tupledArg_1[1];
        const v2_2 = _arg[0];
        const v1_2 = _arg[1];
        const matchValue = segT(v1_2.Pos, v2_2.Pos);
        const matchValue_1 = segT(v2_2.Pos, v3.Pos);
        if (matchValue != null) {
            if (matchValue_1 != null) {
                if (matchValue === matchValue_1) {
                    const d1_1 = matchValue;
                    const d2_1 = matchValue_1;
                    return [[v3, v1_2], vL];
                }
                else {
                    return [[v3, v2_2], cons([v2_2, v1_2], vL)];
                }
            }
            else {
                return [[v2_2, v1_2], vL];
            }
        }
        else {
            return [[v3, v2_2], vL];
        }
    }, [[head(tail(verts)), head(verts)], empty()], tail(tail(verts))), (_arg_1 = tupledArg_2[0], (vL_1 = tupledArg_2[1], (v2_3 = _arg_1[0], (v1_3 = _arg_1[1], equals(segT(v2_3.Pos, v1_3.Pos), undefined) ? vL_1 : cons([v2_3, v1_3], vL_1))))))) : empty()) : empty())));
}

/**
 * This function is given a ConnectionId and it
 * converts the corresponding BusWire.Wire type to a
 * Connection type, offering an interface
 * between our implementation and Issie.
 */
export function extractConnection(wModel, cId) {
    let bind$0040, bind$0040_1;
    const conn = FSharpMap__get_Item(wModel.Wires, cId);
    return new Connection(conn.WId, (bind$0040 = FSharpMap__get_Item(wModel.Symbol.Ports, conn.OutputPort), new Port(bind$0040.Id, undefined, bind$0040.PortType, bind$0040.HostId)), (bind$0040_1 = FSharpMap__get_Item(wModel.Symbol.Ports, conn.InputPort), new Port(bind$0040_1.Id, undefined, bind$0040_1.PortType, bind$0040_1.HostId)), segmentsToIssieVertices(conn.Segments, conn));
}

/**
 * This function is given a list of ConnectionId and it
 * converts the corresponding BusWire.Wire(s) to a
 * list of Connections, offering an interface
 * between our implementation and Issie.
 */
export function extractConnections(wModel) {
    return map((tupledArg) => extractConnection(wModel, tupledArg[0]), toList(wModel.Wires));
}

/**
 * Type passed to wire renderer functions.
 * The data here is cached by React and if the same as last time
 * the render function itself is not called.
 */
export class WireRenderProps extends Record {
    constructor(key, Wire, ColorP, StrokeWidthP, OutputPortEdge, OutputPortLocation, DisplayType, ArrowDisplay, TriangleEdge, InputPortLocation) {
        super();
        this.key = key;
        this.Wire = Wire;
        this.ColorP = ColorP;
        this.StrokeWidthP = StrokeWidthP;
        this.OutputPortEdge = OutputPortEdge;
        this.OutputPortLocation = OutputPortLocation;
        this.DisplayType = DisplayType;
        this.ArrowDisplay = ArrowDisplay;
        this.TriangleEdge = TriangleEdge;
        this.InputPortLocation = InputPortLocation;
    }
}

export function WireRenderProps_$reflection() {
    return record_type("BusWire.WireRenderProps", [], WireRenderProps, () => [["key", string_type], ["Wire", DrawModelType_BusWireT_Wire_$reflection()], ["ColorP", HighLightColor_$reflection()], ["StrokeWidthP", float64_type], ["OutputPortEdge", Edge_$reflection()], ["OutputPortLocation", XYPos_$reflection()], ["DisplayType", DrawModelType_BusWireT_WireType_$reflection()], ["ArrowDisplay", bool_type], ["TriangleEdge", Edge_$reflection()], ["InputPortLocation", XYPos_$reflection()]]);
}

export function renderWireWidthText(props) {
    let textStyle;
    const bind$0040 = Constants_busWidthTextStyle;
    textStyle = (new Text$(bind$0040.TextAnchor, bind$0040.FontSize, bind$0040.FontWeight, bind$0040.FontFamily, HighLightColor__Text(props.ColorP), bind$0040.UserSelect, bind$0040.DominantBaseline));
    const text = (props.Wire.Width === 1) ? "" : int32ToString(props.Wire.Width);
    const outPos = props.OutputPortLocation;
    const yOffset = DrawModelType_BusWireT_TextOffset_get_yOffset();
    const xOffset = DrawModelType_BusWireT_TextOffset_get_xOffset();
    const xLeftOffset = DrawModelType_BusWireT_TextOffset_get_xLeftOffset();
    const matchValue = props.OutputPortEdge;
    switch (matchValue.tag) {
        case 1:
            return makeText(outPos.X + xOffset, outPos.Y + yOffset, text, textStyle);
        case 3:
            return makeText(outPos.X + xOffset, outPos.Y - yOffset, text, textStyle);
        case 2:
            return makeText(outPos.X - xLeftOffset, outPos.Y - yOffset, text, textStyle);
        default:
            return makeText(outPos.X + xOffset, outPos.Y - yOffset, text, textStyle);
    }
}

/**
 * A maximal straight piece of a wire: all of it between two consecutive bends of the shape that
 * is drawn. A wire's segment list is not that shape - it holds zero-length segments, and splits
 * one straight piece over several segments - so radial rendering must work on runs and not on
 * segments, or it rounds a corner where the wire is straight and squares one off where it bends.
 */
export class WireRun extends Record {
    constructor(RunStart, RunEnd, RunOrientation) {
        super();
        this.RunStart = RunStart;
        this.RunEnd = RunEnd;
        this.RunOrientation = RunOrientation;
    }
}

export function WireRun_$reflection() {
    return record_type("BusWire.WireRun", [], WireRun, () => [["RunStart", XYPos_$reflection()], ["RunEnd", XYPos_$reflection()], ["RunOrientation", string_type]]);
}

/**
 * Collapse a wire's absolute segments into the runs between its bends: drop the zero-length
 * segments, which have no shape, and merge whatever is then adjacent and collinear.
 */
export function segmentRuns(absSegments) {
    return reverse(fold((runs, aSeg_1) => {
        let this$_2, delta_1, left_1, right_1, this$_1, delta, left, right;
        let matchResult, earlier_1, run_1;
        if (!isEmpty(runs)) {
            if (head(runs).RunOrientation === ((this$_1 = aSeg_1, (delta = ((left = this$_1.Start, (right = this$_1.End, new XYPos(left.X - right.X, left.Y - right.Y)))), (Math.abs(delta.X) > Math.abs(delta.Y)) ? "horizontal" : "vertical")))) {
                matchResult = 0;
                earlier_1 = tail(runs);
                run_1 = head(runs);
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return cons(new WireRun(run_1.RunStart, aSeg_1.End, run_1.RunOrientation), earlier_1);
            default:
                return cons(new WireRun(aSeg_1.Start, aSeg_1.End, (this$_2 = aSeg_1, (delta_1 = ((left_1 = this$_2.Start, (right_1 = this$_2.End, new XYPos(left_1.X - right_1.X, left_1.Y - right_1.Y)))), (Math.abs(delta_1.X) > Math.abs(delta_1.Y)) ? "horizontal" : "vertical"))), runs);
        }
    }, empty(), filter((aSeg) => !(Math.abs(aSeg.Segment.Length) < 1E-07), absSegments)));
}

/**
 * The bends of a radial wire, each paired with the radius its corner is drawn with. A bend eats
 * `rad` off the end of the run either side of it, so a run with a bend at both ends can give half
 * of itself to each, and one at either end of the wire has a single bend and can give all of
 * itself. The radius is therefore the standard one everywhere except where there is genuinely not
 * the room for it: neighbouring bends never overlap, and a short run is the only thing that
 * squares a corner off.
 */
export function wireBends(runs) {
    const lastRun = (length(runs) - 1) | 0;
    const room = mapIndexed((i, run) => {
        let this$_1, vec_1, left_1, right_1;
        if ((i === 0) ? true : (i === lastRun)) {
            const this$ = run;
            let vec;
            const left = this$.RunStart;
            const right = this$.RunEnd;
            vec = (new XYPos(left.X - right.X, left.Y - right.Y));
            return Math.sqrt(Math.pow(vec.X, 2) + Math.pow(vec.Y, 2));
        }
        else {
            return ((this$_1 = run, (vec_1 = ((left_1 = this$_1.RunStart, (right_1 = this$_1.RunEnd, new XYPos(left_1.X - right_1.X, left_1.Y - right_1.Y)))), Math.sqrt(Math.pow(vec_1.X, 2) + Math.pow(vec_1.Y, 2))))) / 2;
        }
    }, runs);
    return map((tupledArg) => {
        const _arg = tupledArg[0];
        const _arg_1 = tupledArg[1];
        return [_arg[0], _arg[1], min_1(ofArray([Constants_cornerRadius, _arg_1[0], _arg_1[1]]), {
            Compare: (x, y) => (comparePrimitives(x, y) | 0),
        })];
    }, zip(pairwise(runs), pairwise(room)));
}

/**
 * The SVG commands drawing one bend of a radial wire: the line along `before` as far as where the
 * corner starts to be rounded off, then the quarter circle of radius `rad` onto `after`.
 */
export function renderRadialBend(before, after, rad) {
    const corner = before.RunEnd;
    const directionOf = (fromCoord, toCoord) => {
        if (toCoord > fromCoord) {
            return 1;
        }
        else {
            return -1;
        }
    };
    const arc = (bendStart, sweep, bendEnd) => toText(printf("L %f %f A %f %f, 45, 0, %d, %f %f"))(bendStart.X)(bendStart.Y)(rad)(rad)(sweep)(bendEnd.X)(bendEnd.Y);
    if (before.RunOrientation === "vertical") {
        const yDir_1 = directionOf(before.RunStart.Y, corner.Y);
        const xDir_1 = directionOf(corner.X, after.RunEnd.X);
        return arc(new XYPos(corner.X, corner.Y - (yDir_1 * rad)), ((xDir_1 * yDir_1) > 0) ? 0 : 1, new XYPos(corner.X + (xDir_1 * rad), corner.Y));
    }
    else {
        const xDir = directionOf(before.RunStart.X, corner.X);
        const yDir = directionOf(corner.Y, after.RunEnd.Y);
        return arc(new XYPos(corner.X - (xDir * rad), corner.Y), ((xDir * yDir) > 0) ? 1 : 0, new XYPos(corner.X, corner.Y + (yDir * rad)));
    }
}

export function renderModernWire(props) {
    const colour = HighLightColor__Text(props.ColorP);
    const segments = getAbsSegments(props.Wire);
    const lineAttr = join(" ", map((seg) => (`L ${interpolate("%.2f%P()", [seg.End.X])} ${interpolate("%.2f%P()", [seg.End.Y])}`), segments));
    const pathPars = new Path(colour, props.StrokeWidthP.toString(), defaultPath.StrokeDashArray, defaultPath.StrokeLinecap, defaultPath.Fill);
    const circleParameters = new Circle(Constants_modernCircleRadius, colour, defaultCircle.StrokeWidth, defaultCircle.FillOpacity, colour);
    if (Constants_debugWireSegments) {
        const children_2 = map((seg_1) => {
            const p1 = seg_1.Start;
            const p2 = seg_1.End;
            const props_1 = [new SVGAttr(/* X1 */ 42, [p1.X]), new SVGAttr(/* Y1 */ 55, [p1.Y]), new SVGAttr(/* X2 */ 43, [p2.X]), new SVGAttr(/* Y2 */ 56, [p2.Y]), new SVGAttr(/* Stroke */ 30, [defaultArg(tryItem(seg_1.Segment.Index, Constants_rainbowColours), "#000000")]), new SVGAttr(/* StrokeWidth */ 36, [props.StrokeWidthP.toString()])];
            return react.createElement("line", keyValueList(props_1, 1));
        }, segments);
        return react.createElement("g", {}, ...children_2);
    }
    else {
        const children_4 = cons(makeAnyPath(item(0, segments).Start, lineAttr, pathPars), collect((aseg) => map((x) => makeCircle(x, aseg.Start.Y, circleParameters), aseg.Segment.IntersectOrJumpList), segments));
        return react.createElement("g", {}, ...children_4);
    }
}

export function renderJumpSegment(a) {
    let matchValue;
    const sPos = a.Start;
    const ePos = a.End;
    const jR = Constants_jumpRadius;
    const rightTravel = ePos.X > sPos.X;
    const dir = rightTravel ? 1 : -1;
    const makePartArc = (d1, d2) => {
        if ((Math.abs(d1) > jR) ? true : (Math.abs(d2) > jR)) {
            toFail(`d1=${d1}, d2=${d2}, jR=${jR}`);
        }
        return makePartArcAttr(jR, Math.sqrt(max(0, (jR * jR) - (d1 * d1))), d1, Math.sqrt(max(0, (jR * jR) - (d2 * d2))), d2);
    };
    const makeJumpPathAttr = (jLst, xPos) => {
        if (!isEmpty(jLst)) {
            if (Math.abs(head(jLst) - xPos) > jR) {
                return cons(makeLineAttr((head(jLst) - xPos) - (dir * jR), 0), makeJumpPathAttr(jLst, head(jLst) - (dir * (jR - 1E-07))));
            }
            else if (!isEmpty(tail(jLst))) {
                if (Math.abs(head(tail(jLst)) - head(jLst)) > (2 * jR)) {
                    return cons(makePartArc(head(jLst) - xPos, dir * jR), makeJumpPathAttr(tail(jLst), head(jLst) + (dir * jR)));
                }
                else {
                    return cons(makePartArc(head(jLst) - xPos, (head(tail(jLst)) - head(jLst)) / 2), makeJumpPathAttr(tail(jLst), (head(tail(jLst)) + head(jLst)) / 2));
                }
            }
            else if (Math.abs(ePos.X - head(jLst)) < jR) {
                return singleton(makePartArc(head(jLst) - xPos, ePos.X - head(jLst)));
            }
            else {
                return cons(makePartArc(head(jLst) - xPos, dir * jR), makeJumpPathAttr(empty(), head(jLst) + (dir * jR)));
            }
        }
        else {
            return singleton(makeLineAttr(ePos.X - xPos, 0));
        }
    };
    const jLst_1 = map((f) => ((f * dir) + sPos.X), (matchValue = a.Segment.IntersectOrJumpList, rightTravel ? sort(matchValue, {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    }) : sort(matchValue, {
        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
    })));
    const matchValue_2 = Math.abs(sPos.X - ePos.X) < 1E-07;
    let matchResult;
    if (matchValue_2) {
        matchResult = 0;
    }
    else if (isEmpty(jLst_1)) {
        matchResult = 0;
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return singleton(`L ${ePos.X} ${ePos.Y}`);
        default:
            return makeJumpPathAttr(jLst_1, sPos.X);
    }
}

/**
 * Function used to render a single wire if the display type is jump
 */
export function renderJumpWire(props) {
    const absSegments = getAbsSegments(props.Wire);
    const firstVertex = head(absSegments).Start;
    let renderedSegmentList;
    const pathPars = new Path(HighLightColor__Text(props.ColorP), props.StrokeWidthP.toString(), defaultPath.StrokeDashArray, defaultPath.StrokeLinecap, defaultPath.Fill);
    renderedSegmentList = singleton(makeAnyPath(firstVertex, join(" ", collect(renderJumpSegment, absSegments)), pathPars));
    const children = append(singleton(renderWireWidthText(props)), renderedSegmentList);
    return react.createElement("g", {}, ...children);
}

/**
 * Function used to render a single wire if the display type is radial
 */
export function renderRadialWire(props) {
    const absSegments = getAbsSegments(props.Wire);
    const firstVertex = head(absSegments).Start;
    const lastVertex = last(absSegments).End;
    const width = props.StrokeWidthP.toString();
    const pathParameters = new Path(HighLightColor__Text(props.ColorP), width, defaultPath.StrokeDashArray, defaultPath.StrokeLinecap, defaultPath.Fill);
    const bendCommands = join(" ", map((tupledArg) => renderRadialBend(tupledArg[0], tupledArg[1], tupledArg[2]), wireBends(segmentRuns(absSegments))));
    const renderedSVGPath = makePathFromAttr(toText(printf("M %f %f %s L %f %f"))(firstVertex.X)(firstVertex.Y)(bendCommands)(lastVertex.X)(lastVertex.Y), pathParameters);
    const children = append(singleton(renderWireWidthText(props)), singleton(renderedSVGPath));
    return react.createElement("g", {}, ...children);
}

/**
 * Function that will render all of the wires within the model, with the display type being set in Model.Type
 * 
 * `highlighted` says what to show picked out for a reason the draw block cannot know - see
 * DrawModelType.Highlighted. It is applied to the render props rather than to the model, so a
 * wire whose highlight changes redraws and the rest are left to React's memoisation.
 */
export function view(model, highlighted, dispatch) {
    getTimeMs();
    const renderWire = FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E((((value_1("D:\\a\\issie-web\\issie-web\\src\\Renderer\\DrawBlock\\BusWire.fs") + "#L") + int32ToString(value_1(664))) + ";") + "BusWire.WireRenderProps", "Wire", (props) => {
        let wireReact;
        const matchValue_2 = props.DisplayType;
        let matchResult;
        switch (matchValue_2.tag) {
            case 2: {
                if (Constants_debugWireSegments) {
                    matchResult = 2;
                }
                else {
                    matchResult = 1;
                }
                break;
            }
            case 1: {
                if (Constants_debugWireSegments) {
                    matchResult = 2;
                }
                else {
                    matchResult = 2;
                }
                break;
            }
            default:
                if (Constants_debugWireSegments) {
                    matchResult = 2;
                }
                else {
                    matchResult = 0;
                }
        }
        switch (matchResult) {
            case 0: {
                wireReact = renderRadialWire(props);
                break;
            }
            case 1: {
                wireReact = renderJumpWire(props);
                break;
            }
            default:
                wireReact = renderModernWire(props);
        }
        const wireColour = HighLightColor__Text(props.ColorP);
        const polygon = new Polygon(wireColour, defaultPolygon.StrokeWidth, defaultPolygon.FillOpacity, wireColour);
        const y = props.InputPortLocation.Y;
        const x = props.InputPortLocation.X;
        const ws = min(2.5, props.StrokeWidthP);
        let str;
        const matchValue_6 = props.TriangleEdge;
        str = ((matchValue_6.tag === 1) ? (`${x},${y},${x + ws},${y + (2 * ws)},${x - ws},${y + (2 * ws)}`) : ((matchValue_6.tag === 3) ? (`${x},${y},${x + (2 * ws)},${y + ws},${x + (2 * ws)},${y - ws}`) : ((matchValue_6.tag === 2) ? (`${x},${y},${x - (2 * ws)},${y + ws},${x - (2 * ws)},${y - ws}`) : (`${x},${y},${x + ws},${y - (2 * ws)},${x - ws},${y - (2 * ws)}`))));
        const children = append(props.ArrowDisplay ? singleton(makePolygon(str, polygon)) : empty(), singleton(wireReact));
        return react.createElement("g", {}, ...children);
    }, Helpers_equalsButFunctions, undefined, "Of");
    const symbols = view_1(model.Symbol, highlighted.HComps, (arg) => {
        dispatch(new DrawModelType_BusWireT_Msg(/* Symbol */ 0, [arg]));
    });
    const wires = map((tupledArg) => {
        let wire, outputPortLocation, outputPortEdge, model_3, portId_6, portId_3, inputPortLocation, strokeWidthP, matchValue, model_6, portId_13, portId_10;
        return renderWire((wire = tupledArg[1], (outputPortLocation = getPortLocation(undefined, model.Symbol, wire.OutputPort), (outputPortEdge = ((model_3 = model.Symbol, (portId_6 = ((portId_3 = (new DrawModelType_SymbolT_DirectedPortId(/* OutputId */ 1, [wire.OutputPort])), (portId_3.tag === 1) ? portId_3.fields[0] : portId_3.fields[0])), FSharpMap__get_Item(FSharpMap__get_Item(model_3.Symbols, FSharpMap__get_Item(model_3.Ports, portId_6).HostId).PortMaps.Orientation, portId_6)))), (inputPortLocation = getPortLocation(undefined, model.Symbol, wire.InputPort), (strokeWidthP = ((matchValue = (wire.Width | 0), (matchValue === 1) ? 1.5 : ((matchValue < 8) ? 2.5 : 3))), new WireRenderProps(int32ToString(wire.WId), wire, contains(wire.WId, highlighted.HConns) ? HighLightColor.SkyBlue : wire.Color, strokeWidthP, outputPortEdge, outputPortLocation, model.Type, model.ArrowDisplay, (model_6 = model.Symbol, (portId_13 = ((portId_10 = (new DrawModelType_SymbolT_DirectedPortId(/* InputId */ 0, [wire.InputPort])), (portId_10.tag === 1) ? portId_10.fields[0] : portId_10.fields[0])), FSharpMap__get_Item(FSharpMap__get_Item(model_6.Symbols, FSharpMap__get_Item(model_6.Ports, portId_13).HostId).PortMaps.Orientation, portId_13))), inputPortLocation)))))));
    }, toList(model.Wires));
    return react.createElement("g", {}, ...cons(symbols, wires));
}

